import type { AtomModel, Font } from '@/app/editor/iframe/atom/Atom.model';
declare let Liquid: any;
import api from '@/app/endpoints.js';

import { Atom } from '@/app/editor/iframe/atom/Atom';
import HELPER from '@/app/utils/HELPER';
import STORE from '@/app/store/store';
// import utils from "@/app/editor/iframe/atom/utils/index";
import { GET } from '@/app/api/index';
import loadLoopItems from '@/app/utils/loadLoopItems';
import { BaseAtomRender } from '@/app/editor/iframe/atom/atom-service/render/BaseAtomRender';
/**
 * GpProductListRenderService
 */
export class GpProductListRenderService extends BaseAtomRender {
  /**
   * [Hook]
   * renderTemplate
   */
  async renderTemplate(): Promise<void> {
    let templateTmp = this.atom.data.atom.html;
    templateTmp = this.renderSettings(templateTmp); // Render khung cho module và data cho module sử dụng
    this.atom.$el.html(templateTmp); // Cần render settings trước để có khung và các value mặc định(pid)

    const template = HELPER.simpleHTMLEntities(templateTmp);
    const moduleId = this.atom.getId();
    const $bkActiveModule = this.atom.$divContentBk.find('#module-' + moduleId);
    const $settings = $bkActiveModule.find('.settings');
    this.getProductListByCid().catch(() => {
      this.atom.$el.children('.module').attr('data-cid', 'auto').attr('data-chandle', 'latest-products');
      let fields = [];
      fields = this.atom.data.atom.settings;
      for (let i = 0; i < fields.length; i++) {
        if (fields[i].name == 'collection') {
          fields[i]['default_value'] = 'All Collections';
        }
        if (fields[i].name == 'cId') {
          fields[i]['default_value'] = 'auto';
        }
        if (fields[i].name == 'cHandle') {
          fields[i]['default_value'] = 'latest-products';
        }
      }

      $settings.html(JSON.stringify(fields));
      return this.getProductListByCid();
    });
    let html = await this.renderLiquid(template); // render child and render liquid
    html = this.renderSettings(html); // Render render setting id module cho các html childs
    this.atom.$el.html(html);
  }
  /**
   * override renderLiquid từ Atom
   * @param templateTmp template string
   * @returns html string
   */
  async renderLiquid(templateTmp: string): Promise<string> {
    let html = '';
    const template = HELPER.simpleHTMLEntities(templateTmp);
    const jsonData = await this.getProductListByCid();
    if (jsonData && jsonData.products.length == 0) {
      this.atom.$el.find('.module').html('<span style="display: block;text-align:center;">Products not found.</span>');

      HELPER.showNotify('Products not found.', 'error');
    } else {
      // Render liquid
      const tmpl = Liquid.parse(template);
      html = tmpl.render({
        products: jsonData['products'],
      });
      // html = this.formatHtmlWithProduct(product, html);
    }
    return html;
  }
  /**
   * Call ajax to get product form backend
   * @returns data Promise with type ProductShopify
   */
  async getProductListByCid(): Promise<ProductListShopify> {
    return new Promise(async (resolve, reject) => {
      const collectionId = this.atom.$el.children('.module').attr('data-cid');
      const limit: any = this.atom.$el.find('.module').attr('data-limit');
      let isLoading = false;
      const productListData: any = HELPER.searchProductListInList(collectionId, limit) as ProductListShopify;
      const jsonData = {
        products: [],
      };
      if (!jQuery.isEmptyObject(productListData)) {
        if (limit <= productListData['limit']) {
          jsonData.products = productListData['list'];
          if (collectionId != '' && collectionId != 'auto' && jsonData.products.length == 0) {
            let $productList = this.atom.$el;
            if (this.atom.getModuleName() != 'Product List') {
              $productList = this.atom.$gryffEditor.find('.module-wrap[data-label="Product List"]').first();
            }
            const productListId = $productList.attr('data-id');
            const $bkActiveModule = this.atom.$divContentBk.find('#module-' + productListId);
            const $settings = $bkActiveModule.find('.settings');
            let fields = [];
            try {
              fields = JSON.parse($settings.html());
            } catch (err) {
              HELPER.showNotify('error', err.messages);
            }
            for (let i = 0; i < fields.length; i++) {
              if (fields[i].name == 'collection') {
                fields[i]['default_value'] = 'All Collections';
              }
              if (fields[i].name == 'cId') {
                fields[i]['default_value'] = 'auto';
              }
              if (fields[i].name == 'cHandle') {
                fields[i]['default_value'] = 'latest-products';
              }
            }
            $settings.html(JSON.stringify(fields));
            return this.atom.refresh();
          } else {
            window._isFirstLoadCollection = false; //load API tìm CollectionData
            window._collectionJsonData = jsonData;
            resolve(jsonData);
          }
        } else {
          isLoading = true;
        }
      } else {
        isLoading = true;
      }
      if (isLoading) {
        const shop = STORE.getValue('__shop').shopifyDomain;
        const data = {
          shop: shop,
          collectionId: collectionId,
          limit: limit,
        };
        this.showLoading();
        window._isFirstLoadCollection = false;
        const moduleId = this.atom.getId();
        const $bkActiveModule = this.atom.$divContentBk.find('#module-' + moduleId);
        const $settings = $bkActiveModule.find('.settings');
        try {
          const res = await GET(api.getProducts().url, data);
          const jsonData = res.data;
          this.hideLoading();
          const productlistObject = {
            cid: collectionId,
            limit: limit,
            list: jsonData.products,
          };

          HELPER.updateProductListInList(productlistObject);
          for (let i = 0; i < jsonData.products.length; i++) {
            const productData = jsonData.products[i];

            // check the nay de uu tien khi load san pham no update variant.available
            const data = HELPER.searchProductInList(productData.id);
            if (jQuery.isEmptyObject(data)) {
              HELPER.updateProductInList(productData);
            }
          }
          resolve(jsonData);
          //hotfix for Collection Dupplicate API
          window._collectionJsonData = jsonData;
          //run all callback
          let count = 0;
          while (window._collectionStackElement.length && count < 100) {
            count++;
            const _cElement = window._collectionStackElement.pop();
            if (_cElement) {
              (_cElement as any).data('gfmodule').refresh();
            }
          }
        } catch (err) {
          this.atom.$gfFrame.data('gfframe').hideLoading();
          this.hideLoading();
          this.atom.$el.children('.module').attr('data-cid', 'auto').attr('data-chandle', 'latest-products');
          let fields = [];
          fields = this.atom.data.atom.settings;
          for (let i = 0; i < fields.length; i++) {
            if (fields[i].name == 'collection') {
              fields[i]['default_value'] = 'All Collections';
            }
            if (fields[i].name == 'cId') {
              fields[i]['default_value'] = 'auto';
            }
            if (fields[i].name == 'cHandle') {
              fields[i]['default_value'] = 'latest-products';
            }
          }

          $settings.html(JSON.stringify(fields));
          // reject();
          return this.getProductListByCid();
        }
      }
      return false;
    });
  }
  /**
   * @override init child from BaseRender
   * initChilds inside Product wrapper
   */
  initChilds(): void {
    const pageType = this.atom.$gfFrame.data('gfframe').getPageType();
    const moduleIdBk = this.atom.getIdBk();
    const $bkActiveModule = this.atom.$divContentBk.find(moduleIdBk);
    const $templateChildHtml = $bkActiveModule.find('.template-child-html');
    const $templateChildBkHtml = $bkActiveModule.find('.template-child-bkhtml');

    let bkHtml = '',
      html = '';
    if ($templateChildHtml && $templateChildBkHtml && $templateChildHtml.html() && $templateChildBkHtml.html()) {
      html = $templateChildHtml.html();
      html = html.replace(/scri-pt/g, 'script');
      html = HELPER.simpleHTMLEntities(html);
      bkHtml = $templateChildBkHtml.html();
      bkHtml = bkHtml.replace(/scri-pt/g, 'script');
      bkHtml = HELPER.simpleHTMLEntities(bkHtml);
      bkHtml = bkHtml
        .replace(
          '<div class="gf_template-child-bkhtml-product-data"></div>',
          '<script class="data" type="application/json">{"items": [{"content":"<div class=\\"module-wrap\\" id=\\"m-1538714838899-0\\" data-id=\\"1538714838899-0\\" data-label=\\"(P) Image\\"></div><div class=\\"module-wrap\\" id=\\"m-1538714838899-1\\" data-id=\\"1538714838899-1\\" data-label=\\"(P) Title\\"></div><div class=\\"module-wrap\\" id=\\"m-1538714838899-2\\" data-id=\\"1538714838899-2\\" data-label=\\"(P) Price\\"></div><div class=\\"module-wrap\\" id=\\"m-1538714838899-3\\" data-id=\\"1538714838899-3\\" data-label=\\"(P) Cart Button\\"></div>","id":"i-15387148388990"}]}</script>',
        )
        .replace(
          '<div class="gf_template-child-bkhtml-article-data"></div>',
          '<script class="data" type="application/json">{"items": [{"content": "<div class=\\"module-wrap\\" id=\\"m-1523941222422-0\\" data-id=\\"1523941222422-0\\" data-label=\\"(A) Image\\"></div><div class=\\"module-wrap\\" id=\\"m-1523941222422-1\\" data-id=\\"1523941222422-1\\" data-label=\\"(A) Title\\"></div><div class=\\"module-wrap\\" id=\\"m-1523941222422-2\\" data-id=\\"1523941222422-2\\" data-label=\\"(A) Content\\"></div>","id": "i-15239412224220"}]}</script>',
        );

      // Update Preview URL
      if (pageType == 'template-collection') {
        const collectionHandle = this.atom.$el.children('.module').attr('data-chandle');

        let preViewPageLink = this.atom.$gryffEditor.data('gryffeditor').getPreviewPageLink();
        preViewPageLink = preViewPageLink.replace(/&collection(.*)/, '&collection=' + collectionHandle);

        let viewPageLink = this.atom.$gryffEditor.data('gryffeditor').getViewPageLink();
        viewPageLink = viewPageLink.replace(/\/collections\/(.*)/, '/collections/' + collectionHandle);

        this.atom.$gryffEditor.data('gryffeditor').setPreviewPageLink(preViewPageLink);
        this.atom.$gryffEditor.data('gryffeditor').setViewPageLink(viewPageLink);
      }
    } else {
      html =
        '<div data-label="Product" data-key="product" id="m-{{snippet-id}}" class="module-wrap" data-id="{{snippet-id}}"></div>';
      const childrenLayout = [
        {
          label: 'Product',
          key: 'product',
          id: '{{snippet-id}}',
        },
        {
          label: '(P) Image',
          key: 'p-image',
          id: '{{snippet-id}}-0',
        },
        {
          label: '(P) Title',
          key: 'p-title',
          id: '{{snippet-id}}-1',
        },
        {
          label: '(P) Price',
          key: 'p-price',
          id: '{{snippet-id}}-2',
        },
        {
          label: '(P) Cart Button',
          key: 'p-cart-button',
          id: '{{snippet-id}}-3',
        },
      ];
      const childLayoutLength = childrenLayout.length;
      for (let i = 0; i < childLayoutLength; i++) {
        const storeSnippet = this.atom.getDataSnippetByKey(childrenLayout[i].key);
        const $snippet = jQuery(storeSnippet);
        bkHtml += `<div id="module-${childrenLayout[i].id}">`;
        bkHtml += $snippet.html().replace(/{{module-id}}/gim, childrenLayout[i].id);
        bkHtml += '</div>';
      }
    }
    loadLoopItems(this.atom.$el, this.atom.$gryffEditor, this.atom.getId(), this.atom.getLabel(), html, bkHtml);
  }

  /**
   * [Show loading]
   *
   * @returns true/false
   */
  showLoading(): boolean {
    this.atom.$el.gfLoader();
    this.atom.$el.data('gfloader').show();
    return true;
  }
  /**
   * [Hide Loading]
   *
   * @returns true/false
   */
  hideLoading(): boolean {
    this.atom.$el.data('gfloader').hide();
    if (this.atom.$el.find('.gf_loader').length > 0) {
      this.atom.$el.find('.gf_loader').remove();
    }
    return false;
  }
}
type ProductListShopify = {
  products: any[];
};
/**
 * GpProductList
 */
export class GpProductList extends Atom {
  public $el: JQuery;

  /**
   * Thông tin riêng của Atom
   * @returns object watch
   */
  getDataAtom(): AtomModel {
    const data: AtomModel = {
      type: this.getType(),
      id: this.getId(),
      nodeId: this.getIdNode(),
      name: this.getLabel(),
      slug: this.getSlug(),
      groupName: 'Module',
      settings: this.getSettings(),
      data: this.getDataChilds(),
      html: this.getTemplate(),
      class: '.module-wrap',
      style: this.getStyle(),
      script: this.getScript(),
      libs: this.getLibs(),
      fonts: [] as Array<Font>,
      version: 1,
    };
    return data;
  }

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Product List';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'product-list';
  }
  /**
   * get Dât from html attr
   * @returns Group Name
   */
  getGroupName(): string {
    return this.$el.attr('data-groupname') || 'Module';
  }
  /**
   * override renderLiquid từ Atom
   * @param templateTmp template string
   * @returns html string
   */

  /**
   * @override Atom.initAtomRender
   */
  initAtomRender() {
    this.atomRender = new GpProductListRenderService(this);
  }
}
